import { PaymentModuleId } from '../types/PaymentModuleId';
import { PaymentModuleName } from '../types/PaymentModuleName';

export function mapPaymentModuleNameToModuleId(
  m: string,
): PaymentModuleId | undefined {
  switch (m as PaymentModuleName) {
    case PaymentModuleName.BraintreeApplePay:
      return PaymentModuleId.BraintreeApplePay;
    case PaymentModuleName.BraintreeCard:
      return PaymentModuleId.BraintreeCard;
    case PaymentModuleName.BraintreeGooglePay:
      return PaymentModuleId.BraintreeGooglePay;
    case PaymentModuleName.BraintreePayPal:
      return PaymentModuleId.BraintreePayPal;
    case PaymentModuleName.BraintreePayPalPayLater:
      return PaymentModuleId.BraintreePayPalPayLater;
    case PaymentModuleName.WorldpayBancontact:
      return PaymentModuleId.WorldpayBancontact;
    case PaymentModuleName.WorldpayCard:
      return PaymentModuleId.WorldpayCard;
    case PaymentModuleName.WorldpayIdeal:
      return PaymentModuleId.WorldpayIdeal;
    case PaymentModuleName.WorldpayKlarna:
      return PaymentModuleId.WorldpayKlarna;
    case PaymentModuleName.WorldpayJCB:
      return PaymentModuleId.WorldpayJCB;
    case PaymentModuleName.PaymentAtSubsidiary:
      return PaymentModuleId.PaymentAtSubsidiary;
    case PaymentModuleName.Transbank:
      return PaymentModuleId.Transbank;
    case PaymentModuleName.Sepa:
      return PaymentModuleId.Sepa;
    case PaymentModuleName.DirectDebitLSV:
      return PaymentModuleId.DirectDebitLSV;
    case PaymentModuleName.DirectDebitPostFinance:
      return PaymentModuleId.DirectDebitPostFinance;
    case PaymentModuleName.ECommerceConnect:
      return PaymentModuleId.ECommerceConnect;
    case PaymentModuleName.NuveiTwint:
      return PaymentModuleId.NuveiTwint;
    case PaymentModuleName.FlutterwaveCreditCard:
      return PaymentModuleId.FlutterwaveCreditCard;
    case PaymentModuleName.NuveiCreditCard:
      return PaymentModuleId.NuveiCreditCard;
    case PaymentModuleName.BraintreeSepa:
      return PaymentModuleId.BraintreeSepa;
    case PaymentModuleName.PaymentOnDelivery:
      return PaymentModuleId.PaymentOnDelivery;
    case PaymentModuleName.BankTransfer:
      return PaymentModuleId.BankTransfer;
    case PaymentModuleName.Finvoice:
      return PaymentModuleId.Finvoice;
    case PaymentModuleName.TwoCTwoP:
      return PaymentModuleId.TwoCTwoP;
    case PaymentModuleName.ProcessingKZ:
      return PaymentModuleId.ProcessingKZ;
    case PaymentModuleName.Yookassa:
      return PaymentModuleId.Yookassa;
    case PaymentModuleName.RazorPay:
      return PaymentModuleId.RazorPay;
    case PaymentModuleName.DenizBank:
      return PaymentModuleId.DenizBank;
    case PaymentModuleName.PaymentInSubsidiaryCashOnPickup:
      return PaymentModuleId.PaymentInSubsidiaryCashOnPickup;
    case PaymentModuleName.PaymentInSubsidiaryCardViaTerminalOnPickup:
      return PaymentModuleId.PaymentInSubsidiaryCardViaTerminalOnPickup;
    case PaymentModuleName.PayByInvoice:
      return PaymentModuleId.PayByInvoice;
    default:
      return undefined;
  }
}
